import { ActionFunction, ActionParams, DelayedActionFunction } from './types';

const createDelayedAction = <T = any>(action: ActionFunction<T>): DelayedActionFunction<T> => {
  return ({ arg, delay }: ActionParams<T>) => {
    // Если delay не указан или равен 0, выполняем сразу
    if (!delay || delay <= 0) {
      return action(arg);
    }

    // Если delay указан, используем setTimeout
    const timeoutId = setTimeout(() => {
      try {
        action(arg);
      } catch (error) {
        console.error(`Action execution failed after delay ${delay}ms:`, error);
      }
    }, delay);

    // Возвращаем timeoutId для возможности отмены
    return timeoutId;
  };
};

export default createDelayedAction;
